import React, {ReactElement} from 'react';
import notificationIconSrc from '@assets/images/medops/notification.svg';

const NotificationIcon = (props: any): ReactElement => {
  return <img src={notificationIconSrc} {...props} />;
};
export default NotificationIcon;
